var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invite-tenant"},[_c('invite-tenant',{attrs:{"collaborator":!_vm.isBeaconAdmin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }